import cookie from 'js-cookie';
import { useApolloClient } from '@apollo/client';
import { useMemo } from 'react';

const withAuthProvider = () => {
  const apolloClient = useApolloClient();
  return useMemo(() => {
    return {
      login: async () => {
        return true;
      },
      logout: async () => {
        localStorage.removeItem('user');
        cookie.remove('access_token');
        window.location.href = '#/login';

        await apolloClient.resetStore();
      },
      checkError: (error) => {
        const status = error.status;
        if (
          status === 401 ||
          status === 403 ||
          error.message.includes('Not Authorised!')
        ) {
          document.cookie = '';
          localStorage.removeItem('user');
          return Promise.reject({ redirectTo: '/login' });
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
      },
      checkAuth: async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
          return Promise.reject({ redirectTo: '/login' });
        }

        return Promise.resolve(user);
      },
      getPermissions: () => {
        const user = JSON.parse(localStorage.getItem('user'));
        return Promise.resolve({
          presetPassword: user?.presetPassword,
        });
      },
      getIdentity: async () => {
        const user = JSON.parse(localStorage.getItem('user'));

        return Promise.resolve({
          ...user,
          fullName: user.email,
        });
      },
    };
  }, []);
};

export default withAuthProvider;
